import PropTypes from "prop-types";

import { TimePicker } from "components/TimePicker";
import { TradeDaysContainer } from "./TradeDaysEditor.styles";

/**
 * Editable weekly run-schedule grid: one row per day with an active toggle and
 * start/end time pickers. Controlled — the parent owns `days` and applies each
 * change via onChange(index, key, value).
 */
export const TradeDaysEditor = ({ days, onChange, disabled = false }) => {
  return (
    <TradeDaysContainer className="trade-days">
      {days.map((tradeDay, idx) => (
        <div className="trade-day-item" key={tradeDay.day}>
          <input
            className="form-check-input"
            type="checkbox"
            checked={!!tradeDay.is_active}
            disabled={disabled}
            onChange={(e) => onChange(idx, "is_active", e.target.checked)}
          />
          <div className="trade-day">{tradeDay.day}</div>
          <TimePicker
            value={tradeDay.start_date}
            onChange={(value) => onChange(idx, "start_date", value)}
            disabled={disabled || !tradeDay.is_active}
          />
          <div className="time-to">to</div>
          <TimePicker
            value={tradeDay.end_date}
            onChange={(value) => onChange(idx, "end_date", value)}
            disabled={disabled || !tradeDay.is_active}
          />
        </div>
      ))}
    </TradeDaysContainer>
  );
};

TradeDaysEditor.propTypes = {
  days: PropTypes.array.isRequired,
  onChange: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
};
